const W = 96
const H = 32
const PAD = 3
const SEGMENT_GAP = 1.5

/** @param {number[]} values */
export function buildBrokenStepPaths(values) {
  const max = Math.max(...values, 0.001)
  const min = Math.min(...values)
  const range = max - min || 1
  const innerW = W - PAD * 2
  const innerH = H - PAD * 2
  const bottom = H - PAD
  const n = values.length
  if (n === 0) return { segments: [], areas: [], w: W, h: H }

  const colW = innerW / n
  const ys = values.map((v) => PAD + innerH - ((v - min) / range) * innerH)
  const segments = []
  const areas = []

  for (let i = 0; i < n; i += 1) {
    const x0 = PAD + i * colW + SEGMENT_GAP / 2
    const x1 = PAD + (i + 1) * colW - SEGMENT_GAP / 2
    const y = ys[i]
    const seg = `M${x0.toFixed(1)},${y.toFixed(1)} H${x1.toFixed(1)}`
    segments.push(seg)
    areas.push(`${seg} V${bottom.toFixed(1)} H${x0.toFixed(1)} Z`)
  }

  return { segments, areas, w: W, h: H }
}
